import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()

export class ClientService {
	CLIENT_URI: string = environment.apiUrl + '/client';

	constructor(private httpClient: HttpClient) {}

	public getAll = () => {
		return this.httpClient.get(this.CLIENT_URI);
	}

	public getClient = (id) => {
		return this.httpClient.get(this.CLIENT_URI + `/${id}`);
	}

	public getByUser = (body) => {
		return this.httpClient.post(this.CLIENT_URI + `/user`, body);
	}
	
	public create = (body) => {
		return this.httpClient.post(this.CLIENT_URI, body);
  }
  
  public update = (body, id) => {
	  
		return this.httpClient.put(this.CLIENT_URI + `/${id}`, body);
	}
}


// WEBPACK FOOTER //
// ./src/app/services/client.service.ts